import React from 'react';
import { Modal, Typography } from 'antd';
import ScopedSummarySettings from './ScopedSummarySettings';

const { Text } = Typography;

const EntitySummarySettingsModal = ({
  visible,
  onClose,
  entityType,
  entityName,
  entityId,
  customEndpoint,
}) => {

  const titleMap = {
    package: 'Package Summary Settings',
    sub_project: 'Sub-Project Summary Settings',
    project_region: 'Region Summary Settings',
    project_council: 'Council Summary Settings',
  };

  return (
    <Modal
      title={titleMap[entityType] || 'Summary Settings'}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={920}
      destroyOnClose
  bodyStyle={{ maxHeight: '70vh', overflow: 'auto', paddingRight: 16 }}
  style={{ top: 16 }}
    >
      {entityName && (
        <Text type="secondary">For: <strong>{entityName}</strong></Text>
      )}
  <ScopedSummarySettings scopeType={entityType} scopeId={entityId} onClose={onClose} canSave={true} customEndpoint={customEndpoint} />
    </Modal>
  );
};

export default EntitySummarySettingsModal;
